import { jsx as _jsx } from "react/jsx-runtime";
import { Oval } from 'react-loader-spinner';
import { elementColors } from '@sphereon/ui-components.core';
const SSIActivityIndicator = (props) => {
    const { size = 80, color = elementColors.blue, style } = props;
    return (_jsx(Oval, { width: size, height: size, color: color, secondaryColor: color, strokeWidth: 5, strokeWidthSecondary: 5, visible: true, wrapperStyle: style }));
};
export default SSIActivityIndicator;
